import { render, staticRenderFns } from "./switchButton.vue?vue&type=template&id=d67ab3ba&scoped=true"
import script from "./switchButton.vue?vue&type=script&lang=js"
export * from "./switchButton.vue?vue&type=script&lang=js"
import style0 from "./switchButton.vue?vue&type=style&index=0&id=d67ab3ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67ab3ba",
  null
  
)

export default component.exports